import { Component, computed, input } from '@angular/core';
import { SessionTypeEnum } from '../../../shared/models/session-guide.model';

@Component({
  standalone: false,
  selector: 'app-setup-platform-step',
  templateUrl: './setup-platform-step.component.html',
  styleUrls: ['./setup-platform-step.component.scss'],
})
export class SetupPlatformStepComponent {
  selectedSessionType = input.required<SessionTypeEnum>();

  isWithServiceTypeActive = computed(() => this.selectedSessionType() === SessionTypeEnum.WITH_SERVICE_TYPE);
}
